import React from 'react';
import {connect} from 'react-redux';

import PublishBreakModal from 'components/break/BreakPublish/PublishBreakModal';
import {hideUnpublishChallengeStatusModalAction} from "./actions";

const mapStateToProps = (state) => {
    return {
        intlPrefix: 'unpublish',
        isModalOpen: state.publishChallenge.showUnpublishChallengeStatusModal,
        validationErrors: state.publishChallenge.validationErrors,
        successful: state.publishChallenge.successful
    }
};

const mapDispatchToProps = (dispatch) => ({
    handleClose: () => dispatch(hideUnpublishChallengeStatusModalAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishBreakModal);


// WEBPACK FOOTER //
// ./public/pages/BreakPublish/UnpublishBreakModalContainer.jsx